import React from 'react';
import { Box } from '@wix/design-system';
import { MarketingItemRow } from '../MarketingItemRow';
import { groupFeaturesByNamespace } from '../../../utils';
const LAST_CHILD_PADDING_BOTTOM = 'SP3';
export const ProductContainerFeatures = ({ marketingItems, zIndex, highlightedBoxShadow, background, className, wrappers, }) => {
    const groups = groupFeaturesByNamespace(marketingItems);
    return (React.createElement(React.Fragment, null, groups.map((group, groupIndex) => {
        const isAIGroup = group.namespace === 'ai';
        const groupItems = group.items.map((marketingItem, itemIndex) => {
            const actualIndex = group.startIndex + itemIndex;
            const isLastItemInList = actualIndex === marketingItems.length - 1;
            const paddingBottom = !isAIGroup && isLastItemInList ? LAST_CHILD_PADDING_BOTTOM : '0';
            const getPaddingTop = () => {
                const isAfterAIGroup = groupIndex > 0 &&
                    groups[groupIndex - 1]?.namespace === 'ai' &&
                    itemIndex === 0;
                if (isAIGroup) {
                    return '0';
                }
                if (isAfterAIGroup) {
                    return 'SP3';
                }
                return undefined;
            };
            return (React.createElement(MarketingItemRow, { key: actualIndex, item: marketingItem, zIndex: zIndex, maxWidth: isAIGroup ? '206px' : '188px', boxShadow: isAIGroup ? 'none' : highlightedBoxShadow, paddingTop: getPaddingTop(), paddingBottom: paddingBottom, className: className, disabled: marketingItem.disabled }));
        });
        if (isAIGroup && wrappers?.ai) {
            const AIWrapper = wrappers?.ai;
            return (React.createElement(Box, { key: `ai-group-${groupIndex}`, boxShadow: highlightedBoxShadow, width: "100%", background: background ?? 'white', align: "center", paddingTop: "SP3", position: "relative", zIndex: zIndex },
                React.createElement(AIWrapper, null, groupItems)));
        }
        else {
            return (React.createElement(React.Fragment, { key: `regular-group-${groupIndex}` }, groupItems));
        }
    })));
};
//# sourceMappingURL=ProductContainerFeatures.js.map